import { render, staticRenderFns } from "./WsCompareTable.vue?vue&type=template&id=dbb28bac&"
import script from "./WsCompareTable.vue?vue&type=script&lang=js&"
export * from "./WsCompareTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports